import { useContext, useEffect, useMemo, useRef } from "react"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { request } from "../../utils/config"
import { AuthContext } from "../../contexts/auth/AuthContext"
import { ALERTS_FEED_OPTS, fetchAlertsFeed, routeForNotif } from "./NotificationsBell"

/** Bo'lim kaliti — menyu elementi kaliti bilan bir xil: «/orders?id=5» → «/orders» */
export const sectionOf = (path: string) => "/" + (path.split(/[?#]/)[0].split("/")[1] || "")

/**
 * Tog'a #342 / katalog #6024 (#5918, «Notifications/SectionCounts, ReadSection»): menyuda bo'lim badge'lari.
 * 🔔 lentasidagi o'qilmaganlar bildirishnoma ochadigan bo'lim bo'yicha sanaladi (qo'ng'iroq bilan BITTA so'rov/kesh).
 * Bo'lim ochilganda shu bo'limning o'qilmaganlari «o'qildi» bo'ladi (Alerts/SeenAll — foydalanuvchiga xos belgi).
 */
export function useSectionBadges(pathname: string): Record<string, number> {
  const { authState } = useContext(AuthContext)
  const qc = useQueryClient()
  const user = authState?.user
  const { data } = useQuery(["ALERTS_FEED"], fetchAlertsFeed, { enabled: !!user, ...ALERTS_FEED_OPTS })

  const keysBySection = useMemo(() => {
    const m: Record<string, string[]> = {}
    for (const it of (data?.items || []) as any[]) {
      if (it.seen || !it.key) continue
      const to = routeForNotif(it, user)
      if (!to || !to.startsWith("/")) continue
      const sec = sectionOf(to)
      if (sec === "/") continue
      ;(m[sec] = m[sec] || []).push(it.key)
    }
    return m
  }, [data, user])

  const cur = sectionOf(pathname)
  const curKeys = keysBySection[cur] || []
  const sent = useRef("")
  useEffect(() => {
    const sig = cur + "|" + curKeys.join(",")
    if (!curKeys.length || sent.current === sig) return
    sent.current = sig
    request({ url: "Alerts/SeenAll", method: "post", data: curKeys })
      .then(() => qc.invalidateQueries(["ALERTS_FEED"]))
      .catch(() => { /* badge keyingi so'rovda qayta urinadi */ })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cur, curKeys.join(",")])

  return useMemo(() => {
    const counts: Record<string, number> = {}
    for (const [k, v] of Object.entries(keysBySection)) if (k !== cur) counts[k] = v.length
    return counts
  }, [keysBySection, cur])
}
